import styled from "styled-components";
import {
  BREAKPOINT,
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
  SUPER_BREAKPOINT,
} from "../../constants/Styles";

export const Container = styled.div`
  max-width: ${SUPER_BREAKPOINT};
  width: 100%;
  padding: 0 1rem;
`;

export const Body = styled.div`
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size64};
  font-weight: ${FONT_WEIGHT.weight700};
  margin-bottom: 1rem;

  @media (max-width: ${BREAKPOINT}) {
    font-size: ${FONT_SIZE.size32};
  }
`;

export const TitleBlock = styled.div`
  margin-right: 2rem;
`;

export const Description = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size18};
  font-weight: ${FONT_WEIGHT.weight400};
  line-height: 24px;
  margin-bottom: 1rem;
`;

export const ListItem = styled.li`
  margin-left: 1rem;
`;

export const Options = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const SmallerOptionText = styled.div<{ disabled?: boolean }>`
  color: ${COLORS.secondaryLight};
  text-decoration: ${({ disabled }) => (disabled ? "line-through" : "initial")};
`;

export const CapacityExplanation = styled.div`
  color: ${COLORS.secondary};
`;

export const OptionHeader = styled.div<{ disabled?: boolean }>`
  color: ${({ disabled }) =>
    disabled ? COLORS.secondaryLight : COLORS.secondary};
  text-decoration: ${({ disabled }) => (disabled ? "line-through" : "initial")};
  font-size: ${FONT_SIZE.size32};
  font-weight: ${FONT_WEIGHT.weight500};
  font-family: ${FONTS.spaceGrotesk};
`;

export const OptionCard = styled.div<{ width: string }>`
  border-radius: 2rem;
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%),
    ${COLORS.tableBackground};
  padding: 2rem;
  text-align: center;
  width: ${({ width }) => width};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
`;

export const Tables = styled.div`
  overflow: scroll;
`;

export const ButtonWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: center;
`;
